import MessageCenter, { type MessageChannelConfig } from "@/pages/admin/messages/components/MessageCenter";

const config: MessageChannelConfig = {
  channel: "sms",
  eyebrow: "Marketing",
  title: "SMS",
  subtitle: "Short, high-delivery reminders and booking confirmations straight to a visitor's phone.",
  icon: "ri-message-2-line",
  composeTitle: "Send SMS",
  recipientLabel: "Phone number",
  recipientPlaceholder: "+91 98765 43210",
  subjectLabel: "Label",
  subjectPlaceholder: "e.g. Slot reminder",
};

export default function AdminSms() {
  return <MessageCenter config={config} />;
}